import { ChildDataType } from "csv-package";

const isStrings = (value: string[] | ChildDataType[]): value is string[] => {
  return typeof value[0] === "string";
};

export default isStrings;
